<div class="card p-4">
    <ng-container *ngIf="!loading; else loadingContainer">
        <h2>{{ "Size guide" | translate }}</h2>
        <div class="position-relative">
            <div class="sg-page-loading d-flex justify-content-center py-4" *ngIf="catalogLoading">
                <app-loader></app-loader>
            </div>
            <app-size-guide-editor-form [existingGuide]="sizeGuide" (loadingChange)="catalogLoading = $event"></app-size-guide-editor-form>
        </div>
        <div class="separator my-2"></div>
        <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-primary" (click)="save()">{{ "Save" | translate }}</button>
        </div>
    </ng-container>
    <ng-template #loadingContainer>
        <div class="text-center py-4">
            <app-loader></app-loader>
        </div>
    </ng-template>
</div>
